import { Timeframe } from "../../models/enum/timeframe.enum";

export class TimeFrameToChartTimeFrameMapper {
    static map(timeframeString: string): Timeframe {
        const timeframeUpperCase = timeframeString?.trim()?.toUpperCase() ?? '';
        switch (timeframeUpperCase) {
            case '1M' || 'ONEMINUTE': {
                return Timeframe.OneMinute;
            }
            case '2M' || 'TWOMINUTE': {
                return Timeframe.TwoMinute;
            }
            case '3M' || 'THREEMINUTE': {
                return Timeframe.ThreeMinute;
            }
            case '5M' || 'FIVEMINUTE': {
                return Timeframe.FiveMinute;
            }
            case '10M' || 'TENMINUTE': {
                return Timeframe.TenMinute;
            }
            case '15M' || 'FIFTEENMINUTE': {
                return Timeframe.FifteenMinute;
            }
            case '30M' || 'THIRTYMINUTE': {
                return Timeframe.ThirtyMinute;
            }
            case '60M' || '1H' || 'SIXTYMINUTE': {
                return Timeframe.SixtyMinute;
            }
            case '1D' : {
                return Timeframe.Day;
            }
            case '1W' : {
                return Timeframe.Week;
            }
            case '1MONTH' : {
                return Timeframe.Month;
            }
            default: {
                throw  new Error(`timeframe string not supported yet: ${timeframeString}`);
            }
        }
    }

    static mapTimespan(timespanString: string): Timeframe {
        const timespanUpperCase = timespanString?.trim()?.toUpperCase() ?? '';
        switch (timespanUpperCase) {
            case '1M' || 'ONEMONTH': {
                return Timeframe.OneMonthRange;
            }
            case '6M' || 'SIXMONTH': {
                return Timeframe.SixMonthRange;
            }
            case 'YTD' || 'YEARTODATE': {
                return Timeframe.YearToDateRange;
            }
            case '1Y' || 'ONEYEAR': {
                return Timeframe.OneYearRange;
            }
            case '5Y' ||'FIVEYEAR': {
                return Timeframe.FiveYearRange;
            }
            default: {
                throw  new Error(`timespan string not supported yet: ${timespanString}`);
            }
        }
    }
}